'use strict';

angular.module('shiftTraderApp')
  .factory('OverlayManagementService', function() {
    var overlays = [];

    var removeOverlayIndicies = function(indices) {
      _.each(indices.reverse(), function(idx) {
        overlays.splice(idx, 1);
      });
    };

    var addOverlay = function(type, id, closeFn) {
      var overlayIndicesToRemove = [];
      _.each(overlays, function(overlay, idx) {
        if (overlay.type === type) {
          overlay.closeFn();
          overlayIndicesToRemove.push(idx);
        }
      });

      removeOverlayIndicies(overlayIndicesToRemove);

      overlays.push({
        type: type,
        id: id,
        closeFn: closeFn
      });
    };

    var removeOverlay = function(type, id) {
      var overlayIndicesToRemove = [];
      _.each(overlays, function(overlay, idx) {
        if (type === overlay.type && id === overlay.id) {
          overlayIndicesToRemove.push(idx);
        }
      });

      removeOverlayIndicies(overlayIndicesToRemove);
    };

    var clearOverlays = function(type, id) {
      var queryData = {};
      if (!_.isUndefined(type) && !_.isNull(type)) {
        queryData.type = type;
      }

      if (!_.isUndefined(id) && !_.isNull(id)) {
        queryData.id = id;
      }

      var overlayIndicesToRemove = [];
      _(overlays).where(_.keys(queryData).length > 0 ? queryData : undefined).each(function(overlay, idx) {
        overlay.closeFn();
        overlayIndicesToRemove.push(idx);
      });

      removeOverlayIndicies(overlayIndicesToRemove);
    };


    return {
      addOverlay: addOverlay,
      removeOverlay: removeOverlay,
      clearOverlays: clearOverlays
    }
  });
